// import { axiosPrivate } from "../utils/Utils"; // No longer needed here

const API_BASE_URL = "/tags";

export const createTag = async (axios, tagData) => {
    try {
        const response = await axios.post(API_BASE_URL, tagData);
        return response.data;
    } catch (error) {
        console.error("Error creating tag:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const getAllTags = async (axios, search = "") => { // Added search parameter for consistency
    try {
        const endpoint = search ? `${API_BASE_URL}?search=${encodeURIComponent(search)}` : API_BASE_URL;
        const response = await axios.get(endpoint);
        return response.data;
    } catch (error) {
        console.error("Error fetching all tags:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const getTagById = async (axios, tagId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/${tagId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching tag with ID ${tagId}:`, error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const updateTag = async (axios, tagId, tagData) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/${tagId}`, tagData);
        return response.data;
    } catch (error) {
        console.error(`Error updating tag with ID ${tagId}:`, error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deleteTag = async (axios, tagId) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/${tagId}`);
        return response.data; // For 204 No Content, response.data will be undefined.
    } catch (error) {
        console.error(`Error deleting tag with ID ${tagId}:`, error.response?.data || error.message);
        throw error.response?.data || error;
    }
};